// Helpers genéricos para validar y filtrar valores de inputs
// pensando en onChange (incluye teclas, pegado, autofill, etc.).

// Regex para solo dígitos (incluye cadena vacía mientras el usuario escribe)
export const regexSoloDigitos = /^\d*$/;

/**
 * Recibe el nuevo valor del input y una regex que debe matchear
 * TODO el string. Si no matchea, devuelve esValido=false y no
 * se debe actualizar el estado ni el store.
 */
export const filtrarPorRegex = (valorNuevo, regexValue) => {
  if (valorNuevo === undefined || valorNuevo === null) {
    return { esValido: false, valorSanitizado: null };
  }

  const esValido = regexValue.test(valorNuevo);

  return {
    esValido,
    valorSanitizado: esValido ? valorNuevo : null,
  };
};







